import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid default-dashboard" }
const _hoisted_2 = { class: "row widget-grid" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexDefault',
  setup(__props) {

const WelcomeView = defineAsyncComponent(() => import("@/components/theme/dashboards/default/WelcomeView.vue"))
const OpeningLeaflets = defineAsyncComponent(() => import("@/components/common/OpeningLeaflets.vue"))
const ShiftsOverview = defineAsyncComponent(() => import("@/components/theme/dashboards/default/ShiftsOverview.vue"))
const CustomerTransaction = defineAsyncComponent(() => import("@/components/theme/dashboards/default/CustomerTransaction.vue"))
const NotificationsData = defineAsyncComponent(() => import("@/components/theme/dashboards/default/NotificationsData.vue"))
const AppointmentsData = defineAsyncComponent(() => import("@/components/common/AppointmentsData.vue"))
const ActiveMembers = defineAsyncComponent(() => import("@/components/theme/dashboards/default/ActiveMembers.vue"))
const SalesStatistic = defineAsyncComponent(() => import("@/components/theme/dashboards/default/SalesStatistic.vue"))
const SaleProduct = defineAsyncComponent(() => import("@/components/theme/dashboards/default/SaleProduct.vue"))
const ProjectData = defineAsyncComponent(() => import("@/components/theme/dashboards/default/ProjectData.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(WelcomeView)),
      _createVNode(_unref(OpeningLeaflets), {
        doller: "$",
        col: "col-xl-3 col-md-6 proorder-xl-2 proorder-md-2"
      }),
      _createVNode(_unref(ShiftsOverview)),
      _createVNode(_unref(ProjectData)),
      _createVNode(_unref(CustomerTransaction)),
      _createVNode(_unref(NotificationsData)),
      _createVNode(_unref(AppointmentsData), {
        col: "col-xxl-5 col-xl-6 box-col-6 proorder-xl-7 proorder-md-8",
        bodyclass: "appointments relative"
      }),
      _createVNode(_unref(ActiveMembers)),
      _createVNode(_unref(SalesStatistic)),
      _createVNode(_unref(SaleProduct))
    ])
  ]))
}
}

})